import device from './device'
import user from './user'
import position from './position'
import classification from './classification'
import competition from './competition'
import location from './location'
import trackpoint from './trackpoint'
import gpxFile from './gpx-file'
import player from './player'
import deviceSummary from './device-summary'
import competitionLayout from './competition-layout'
export default {
    classification,
    competition,
    device,
    gpxFile,
    location,
    user,
    position,
    player,
    trackpoint,
    deviceSummary,
    competitionLayout,
}
